import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import {
  Drawer,
  MenuItem,
  Modal,
  Paper,
  TextField,
  Typography
} from '@material-ui/core';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import Header from '../../components/Header';
import MenuDrawer from '../../components/MenuDrawer';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import SearchButton from '../../components/atoms/SearchButton';
import { getAccounts } from '../../actions/Accounts';
import {
  getTicketsUsedByAdmin,
  GET_TICKETS_USED_BY_ADMIN_SUCCESS,
  downloadTicketsUsedByAdmin
} from '../../actions/Tickets';
import { getSystems } from '../../actions/Systems';
import ShashokuTicketUsedByAdminTable from '../organisms/ShashokuTicketUsedByAdminTable';
import CommonButton from '../../components/atoms/CommonButton';
import ShashokuTicketUsedByAdminAdd from '../organisms/ShashokuTicketUsedByAdminAdd';

const styles = {
  root: {},
  searchForm: {
    padding: '10px 26px 10px 26px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  buttonGroupRight: {
    textAlign: 'right'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      systems: state.systems.list
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getTicketsUsedByAdmin,
          getSystems,
          downloadTicketsUsedByAdmin
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAdd', 'setOpenAdd', false),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('fromSystemId', 'setFromSystemId', null),
  withState('displayName', 'setDisplayName', null),
  withState('shopName', 'setShopName', null),
  withState('menuName', 'setMenuName', null),
  withState('fromDate', 'setFromDate', null),
  withState('toDate', 'setToDate', null),
  withState('page', 'setPage', 1),
  withState('openTable', 'updateOpenTable', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('loading', 'updateLoading', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('selectedTicketIds', 'setSelectedTicketIds', []),
  withState('errorMessage', 'setErrorMessage', ''),
  withState('downloadParams', 'setDownloadParams', {}),
  withHandlers({
    checkSession: props => data => {
      if (
        data.error === true &&
        typeof data.payload !== 'undefined' &&
        data.payload.status === 403
      ) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withHandlers({
    handleChangePage: props => (event, page, limit) => {
      const limitNum = limit || props.rowsPerPage;
      console.log('HANDLE CHANGE PAGE');
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      props.setPage(page);
      const searchKey = {
        fromSystemId: props.fromSystemId,
        displayName: props.displayName,
        shopName: props.shopName,
        menuName: props.menuName,
        ticketUseDateFrom: props.fromDate,
        ticketUseDateTo: props.toDate,
        page,
        limit: limitNum
      };

      props.setDownloadParams(searchKey);

      props.updateLoading(true);
      props.updateOpenProgress(true);
      props.actions.getTicketsUsedByAdmin(searchKey).then(data => {
        props.checkSession(data);
        if (data.type === GET_TICKETS_USED_BY_ADMIN_SUCCESS) {
          props.updateOpenProgress(false);
          props.setResultMessage('');
          props.updateLoading(false);
          props.updateOpenTable(true);
        } else {
          props.setErrorMessage('エラーが発生しました！');
          props.updateLoading(false);
          props.updateOpenProgress(false);
        }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
        this.props.actions.getSystems();
        this.props.handleChangePage(null, 1, this.props.rowsPerPage);
      });
    }
  })
);

const Main = enhance(
  ({
    openAdd,
    setOpenAdd,
    classes,
    openDrawer,
    updateOpenDrawer,
    account,
    openTable,
    updateOpenTable,
    openProgress,
    updateOpenProgress,
    page,
    handleChangePage,
    loading,
    updateLoading,
    rowsPerPage,
    setRowsPerPage,
    resultMessage,
    setResultMessage,
    fromSystemId,
    setFromSystemId,
    displayName,
    setDisplayName,
    shopName,
    setShopName,
    menuName,
    setMenuName,
    fromDate,
    setFromDate,
    toDate,
    setToDate,
    systems,
    errorMessage,
    setErrorMessage
  }) => {
    const searchAction = async () => {
      updateOpenTable(true);
      handleChangePage(null, 1, rowsPerPage);
    };

    const progress = {
      loading,
      updateLoading,
      openProgress,
      updateOpenProgress,
      setResultMessage
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      updateLoading(true);
      handleChangePage(null, page, rowsPerPage);
    };

    function onSuccess() {
      setOpenAdd(false);
      searchAction();
    }
    return (
      <div className={classes.root}>
        <Header
          onMenuClick={() => {
            updateOpenDrawer(true);
          }}
        />
        <Drawer
          open={openDrawer}
          anchor="left"
          onClose={() => {
            updateOpenDrawer(false);
          }}
        >
          <div tabIndex={0} role="button">
            <MenuDrawer account={account} />
          </div>
        </Drawer>
        <div className={classes.pageTitileDiv}>
          <Typography variant="h6" color="textSecondary">
            社食ごちめしのチケット編集
          </Typography>
        </div>
        <Paper className={classes.mainPaper} elevation={1}>
          <div className={classes.searchForm}>
            <TextField
              select
              label="会社名"
              className={classes.textField}
              margin="normal"
              value={fromSystemId}
              onChange={e => {
                setFromSystemId(e.target.value || '');
              }}
              InputLabelProps={{
                shrink: fromSystemId
              }}
            >
              <MenuItem id="">選択なし</MenuItem>
              {systems.map(item => {
                return (
                  <MenuItem
                    key={item.connectSystemId}
                    value={item.connectSystemId}
                  >
                    {item.connectSystemName}
                  </MenuItem>
                );
              })}
            </TextField>
            <TextField
              label="社員名"
              type="search"
              className={classes.textField}
              margin="normal"
              value={displayName}
              onChange={e => {
                setDisplayName(e.target.value);
              }}
            />
            <TextField
              label="店舗名"
              type="search"
              className={classes.textField}
              margin="normal"
              value={shopName}
              onChange={e => {
                setShopName(e.target.value);
              }}
            />
            <TextField
              label="メニュー名"
              type="search"
              className={classes.textField}
              margin="normal"
              value={menuName}
              onChange={e => {
                setMenuName(e.target.value);
              }}
            />
            <TextField
              label="利用日(From)"
              type="date"
              className={classes.textField}
              margin="normal"
              value={fromDate}
              inputProps={{
                max: toDate
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setFromDate(e.target.value);
              }}
            />
            <TextField
              label="利用日(To)"
              type="date"
              className={classes.textField}
              margin="normal"
              value={toDate}
              inputProps={{
                min: fromDate
              }}
              InputLabelProps={{
                shrink: true
              }}
              onChange={e => {
                setToDate(e.target.value);
              }}
            />
            <div className={classes.buttonGroupLeft}>
              <SearchButton onClickAction={searchAction} />
            </div>
            <div className={classes.buttonGroupRight}>
              <CommonButton
                title="データ修正追加"
                onClickAction={() => setOpenAdd(true)}
                secondary
              />
            </div>
          </div>
          {openTable && (
            <ShashokuTicketUsedByAdminTable
              page={page}
              handleChangePage={handleChangePage}
              progress={progress}
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              setResultMessage={setResultMessage}
              updateOpenProgress={updateOpenProgress}
              updateLoading={updateLoading}
            />
          )}
        </Paper>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />

        <ProgressDialog
          openProgress={errorMessage !== ''}
          progressOkAction={() => setErrorMessage('')}
          loading={false}
          resultMessage={errorMessage}
        />

        <Modal open={openAdd}>
          <ShashokuTicketUsedByAdminAdd
            onSuccess={onSuccess}
            setOpenAdd={setOpenAdd}
          />
        </Modal>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
